module.exports = __webpack_public_path__ + "static/media/Help.0e3f3f36.svg";